import { Component, OnInit } from '@angular/core';
import { MasterService } from 'app/services/master/master.service';
import { MstHarassmentTypeModel } from 'app/model/mst.harassmentType.model';
import { fail } from 'assert';
import { FormBaseComponent } from 'app/components/form/form-base.component';

@Component({
    selector: 'form-harassment-type',
    templateUrl: './form-harassment-type.component.html',
    styleUrls: ['./form-harassment-type.component.scss']
})
export class FormHarassmentTypeComponent extends FormBaseComponent implements OnInit {

    harassmentTypes: Array<MstHarassmentTypeModel & {changed?: boolean, valid?: boolean}>
    validAll : boolean;

    /** 入力モード */
    confirmation: boolean;

    constructor(private masterService: MasterService) { 
        super();
    }

    /**
     * 初期処理
     */
    async ngOnInit() {

        try {
            this.loading.emit(true);
            this.confirmation = false;
            this.harassmentTypes = await this.masterService.getHarassmentTypes();
            this.harassmentTypes.forEach(item => {
                item.changed = false;
                item.valid = false;
            })
            this.validAll = false;

        } catch(err) {
            this.alert('danger', err.message);
        } finally {
            this.loading.emit(false);
        }
    }

    /**
     * 新規行追加
     */
    addRow() {
        this.harassmentTypes.push(
            Object.assign(
                new MstHarassmentTypeModel(), 
                {
                    changed: false, 
                    valid: false, 
                    del:false
                }));
    }


    /**
     * 入力チェック処理
     */
    validateForm(form) {
        if (form.invalid)  {
            this.validAll = true;
            return;
        }

        for (let item of this.harassmentTypes) {
            if ((!item.id && !item.del) || (item.id && item.del) || (item.id && item.changed)) {
                this.confirmation = true;
                return;
            }
        }
    }

    /**
     * 入力内容を更新する
     */
    async updateForm() {

        try {
            this.loading.emit(true);

            let updateList: Array<MstHarassmentTypeModel> = [];

            this.harassmentTypes.forEach(item => {

                if ((!item.id && !item.del) || (item.id && item.del) || (item.id && item.changed)) {
                    updateList.push(Object.assign({}, item));
                }
            });

            await this.masterService.updateHarassmentTypes(updateList);

            this.alert('success', '相談区分マスタを更新しました。', 7000);

            await this.ngOnInit();

        } catch(err) {
            this.alert('danger', err.message);
            this.confirmation = true;
            console.error(err);
        } finally {
            this.loading.emit(false);
        }
    }

    trackByIndex(index: number, value: number) {
        return index;
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form-setting/form-harassment-type.component.ts